import { useEffect, useState } from 'react';
import Bowser from 'bowser';
import NotificationBanner from '../NotificationBanner';
import { useTranslation } from 'react-i18next';

export default function OldBrowserNotificationBanner() {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [isOldBrowser, setIsOldBrowser] = useState<boolean>();

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    if (
      browser.satisfies({
        safari: '>14.1',
        chrome: '>100',
        firefox: '>100',
        edge: '>100',
        opera: '>86',
      })
    ) {
      setIsOldBrowser(false);
    } else {
      setIsOldBrowser(true);
    }
  }, []);

  return (
    <>
      {isOldBrowser && (
        <NotificationBanner variant="danger" dismissible>
          {t('COMPONENTS.NOTIFICATION_BAR.OLD-BROWSER.TEXT')}{' '}
          <a href={`https://outdatedbrowser.com/${language}`} target="_blank" rel="noreferrer">
            {t('COMPONENTS.NOTIFICATION_BAR.OLD-BROWSER.UPDATE_LINK_TEXT')}
          </a>
        </NotificationBanner>
      )}
    </>
  );
}
